export default "__VITE_ASSET__287a8483__"